import { render, staticRenderFns } from "./live-header.vue?vue&type=template&id=14ba64d6&scoped=true"
import script from "./live-header.vue?vue&type=script&lang=js"
export * from "./live-header.vue?vue&type=script&lang=js"
import style0 from "./live-header.vue?vue&type=style&index=0&id=14ba64d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba64d6",
  null
  
)

export default component.exports